"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8700],{

/***/ 38700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ multimedia_ImageLogo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/atoms/multimedia/ImageLogo/ImageLogo.tsx


/**
 * ImageLogo
 */ var ImageLogo = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, imageBase = param.imageBase, imageAbove = param.imageAbove, heightAbove = param.heightAbove, widthAbove = param.widthAbove;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex w-full items-center justify-center rounded-t-md ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imageBase,
                layout: "fill",
                alt: "Image Becasa",
                "aria-label": "image of becasa",
                objectFit: "cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imageAbove,
                height: heightAbove,
                width: widthAbove,
                alt: "Logo BeCasa",
                "aria-label": "logo-becasa"
            })
        ]
    });
};
ImageLogo.displayName = "ImageLogo";

;// CONCATENATED MODULE: ./components/atoms/multimedia/ImageLogo/index.ts

/* harmony default export */ var multimedia_ImageLogo = (ImageLogo);


/***/ })

}]);